import React, { useContext } from 'react';
import { LocalizationContext } from "../context/LocalizationContext";
import { SelectedFormContext } from "../context/SelectedFormContext";

function FormDetails() {
    const i18n = useContext(LocalizationContext);
    const { formData } = useContext(SelectedFormContext);

    return (
        <div className="slds-is-relative">
            <div className="slds-p-bottom_medium">
                <h2 className="slds-text-heading_small">{i18n.get('EVENT_LABEL_ATTRIBUTES')}</h2>
            </div>

            {!formData ? (
                <div className="slds-text-color_weak slds-text-body_small">
                    {i18n.get('ATTRIBUTES_EMPTY')}
                </div>
            ) : (
                <div>
                    <div className="slds-text-title slds-m-bottom_x-small">
                        {i18n.get('SUMMARY_LABEL_DATA_TARGET')}
                    </div>
                    <div className="slds-m-bottom_medium">
                        {formData.dataTargetName}
                    </div>

                    {formData.fields && formData.fields.length > 0 && (
                            <ul className="slds-list_dotted">
                                {formData.fields.map((field, index) => (
                                    <li key={index} className="slds-item">
                                        {field.name}
                                    </li>
                                ))}
                            </ul>
                    )}
                </div>
            )}
        </div>
    );
}

export default FormDetails;